import {wizard} from '@/config/sites'

const navigateToTab = () => {
  window.open(`crea-kit`, '_blank')
}

export default {
  'bindTo': false,
  'method': navigateToTab,
}
